export default __webpack_public_path__ + "static/media/signup.f535f5e2.jpg";